"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StockStatus = StockStatusComponent;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("../../fuse-typography-element/src/typography");
var _excluded = ["dataTestId", "stockStatus", "statusMessage", "size", "variant"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var propTypes = {
  dataTestId: _propTypes["default"].string,
  stockStatus: _propTypes["default"].string,
  statusMessage: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['inStock', 'outOfStock', 'preOrder', 'lowStock', 'awaitingStock']),
  size: _propTypes["default"].oneOf(['s', 'xs', 'xxs'])
};
var defaultProps = {
  dataTestId: null,
  stockStatus: null,
  statusMessage: null,
  variant: 'inStock',
  size: 's'
};
var linkConfig = {
  inStock: {
    color: 'var(--color-universal-greenMid)'
  },
  outOfStock: {
    color: 'var(--color-universal-redMid)'
  },
  preOrder: {
    color: 'var(--color-universal-bronzeMid)'
  },
  lowStock: {
    color: 'var(--color-universal-bronzeMid)'
  },
  awaitingStock: {
    color: 'var(--color-universal-greenMid)'
  },
  s: {
    fontSize: '1',
    spacing: 'var(--spacing-global-space2);'
  },
  xs: {
    fontSize: 'm1',
    spacing: 'var(--spacing-global-space2);'
  },
  xxs: {
    fontSize: 'm2',
    spacing: 'var(--spacing-global-space1);'
  }
};
var StyledStockStatus = _styledComponents["default"].div.withConfig({
  displayName: "stock-status__StyledStockStatus",
  componentId: "sc-19jyby6-0"
})(["display:grid;grid-template-columns:1fr;", ""], function (_ref) {
  var size = _ref.size;
  return "\n\t\tgrid-row-gap: ".concat(linkConfig[size].spacing, ";\n\t");
});
var StockStatus = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  type: 'heading',
  tag: 'p'
}).withConfig({
  displayName: "stock-status__StockStatus",
  componentId: "sc-19jyby6-1"
})(["display:grid;", ""], function (_ref2) {
  var variant = _ref2.variant;
  return "\n\t\tcolor: ".concat(linkConfig[variant].color, ";\n\t");
});
var StatusMessage = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  size: 'm2',
  type: 'paragraph'
}).withConfig({
  displayName: "stock-status__StatusMessage",
  componentId: "sc-19jyby6-2"
})(["display:grid;margin:0;"]);
function StockStatusComponent(_ref3) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref3), _ref3));
  var dataTestId = props.dataTestId,
    stockStatus = props.stockStatus,
    statusMessage = props.statusMessage,
    size = props.size,
    variant = props.variant,
    others = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledStockStatus, _extends({
    "data-testid": dataTestId,
    size: size
  }, others), /*#__PURE__*/_react["default"].createElement(StockStatus, {
    size: linkConfig[size].fontSize,
    variant: variant
  }, stockStatus), /*#__PURE__*/_react["default"].createElement(StatusMessage, null, statusMessage));
}
StockStatusComponent.propTypes = propTypes;
StockStatusComponent.defaultProps = defaultProps;
var _default = exports["default"] = StockStatusComponent;